import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Switch, Route, Redirect } from 'react-router';

import { history } from './config/store';
import TwigListing from './pages/TwigListing';
import GetById from './pages/GetById';
import Cart from './pages/Cart';
import BusinessRegister from './pages/BusinessRegister';
import ContentRegister from './pages/ContentRegister';

import PrivateRoute from './components/PrivateRoute';
import Landing from './pages/Landing';
import GuestRoute from './components/GuestRoutes';
import Discover from './pages/Discover';
import Search from './pages/Search';
import ContactUs from './pages/contactUs';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundAndCancellationPolicy from './pages/RefundAndCancellationPolicy';
import ShippingAndReturnPolicy from './pages/ShippingAndReturnPolicy';
import AboutUs from './pages/AboutUs';

export interface RoutesProps { }

const Routes: React.FC<RoutesProps> = () => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route exact path="/home" component={Landing} />
        {/* <PrivateRoute exact path="/" component={TwigListing} /> */}
        <Route exact path="/Explorer"
          // component={TwigListing}
          render={(props) => (
            <TwigListing {...props} />
          )}
        />
        <Route exact path="/discover"
          // component={Discover}
          render={(props) => (
            <Discover {...props} />
          )}

        />
        <Route exact path="/cart"
          //  component={Cart} 
          render={(props) => (
            <Cart {...props} />
          )}
        />
        <Route exact path="/register"
          render={(props) => (
            <BusinessRegister {...props} />
          )}
        />
        <Route exact path="/creator" render={(props) => (
          <ContentRegister {...props} />
        )} />
        <Route exact path="/search"
          // component={Search}
          render={(props) => (
            <Search {...props} />
          )}
        />
        <Route path='/offers' render={() => 
            (
              <Redirect to="search?searchKey=&tab=offers"/>
            )
        }/>

        <Route exact path="/contact-us"
          // component={Search}
          render={(props) => (
            <ContactUs {...props} />
          )}
        />
        <Route exact path="/terms-and-conditions"
          // component={Search}
          render={(props) => (
            <TermsConditions {...props} />
          )}
        />
        <Route exact path="/privacy-policy"
          // component={Search}
          render={(props) => (
            <PrivacyPolicy {...props} />
          )}
        />
        <Route exact path="/refund-and-cancellation-policy"
          // component={Search}
          render={(props) => (
            <RefundAndCancellationPolicy {...props} />
          )}
        />

        <Route exact path="/shipping-and-return-policy"
          // component={Search}
          render={(props) => (
            <ShippingAndReturnPolicy {...props} />
          )}
        />

        <Route exact path="/about-us"
          // component={Search}
          render={(props) => (
            <AboutUs {...props} />
          )}
        />
        <Route exact path="/:id"
          // component={GetById}
          render={(props) => (
            <GetById {...props} />
          )}
        />
        
        <Redirect to="/Explorer" />
      </Switch>
    </ConnectedRouter>
  );
};

export default Routes;
